// Mutaciones moddle puras para "promover" un input a InputData del DRD.
// El callsite (EpxDmn._promoteInputToDrd) se encarga de los aspectos visuales
// (DMNShape, edges) — esta capa es solo transformación del árbol moddle.

function uid() {
  return Math.random().toString(36).slice(2, 10);
}

export function ensureInputDataForName({ moddle, definitions, name, typeRefHint }) {
  const existing = (definitions.drgElement || []).find(
    (e) => e.name === name && e.$type === 'dmn:InputData'
  );
  if (existing) return { inputData: existing, created: false };

  const id = 'InputData_' + uid();
  const variable = moddle.create('dmn:InformationItem', {
    id: id + '_var',
    name,
    typeRef: typeRefHint || 'string',
  });
  const inputData = moddle.create('dmn:InputData', { id, name, variable });
  variable.$parent = inputData;
  inputData.$parent = definitions;
  if (!definitions.drgElement) definitions.drgElement = [];
  definitions.drgElement.push(inputData);
  return { inputData, created: true };
}

export function ensureFormalParameterForBkm({ moddle, bkm, name, typeRefHint }) {
  let fnDef = bkm.encapsulatedLogic;
  if (!fnDef || fnDef.$type !== 'dmn:FunctionDefinition') {
    const wrapped = moddle.create('dmn:FunctionDefinition', {
      id: 'FunctionDef_' + uid(),
      formalParameter: [],
      body: fnDef || moddle.create('dmn:LiteralExpression', { id: 'LE_' + uid(), text: '' }),
    });
    if (wrapped.body) wrapped.body.$parent = wrapped;
    wrapped.$parent = bkm;
    bkm.encapsulatedLogic = wrapped;
    fnDef = wrapped;
  }

  if (!fnDef.formalParameter) fnDef.formalParameter = [];
  const existing = fnDef.formalParameter.find((p) => p.name === name);
  if (existing) return { parameter: existing, created: false };

  const param = moddle.create('dmn:InformationItem', {
    id: 'FP_' + uid(),
    name,
    typeRef: typeRefHint || 'string',
  });
  param.$parent = fnDef;
  fnDef.formalParameter.push(param);
  return { parameter: param, created: true };
}

export function ensureInformationRequirement({ moddle, decision, inputData }) {
  const targetHref = '#' + inputData.id;
  const exists = (decision.informationRequirement || []).some((req) => {
    const ref = req.requiredInput;
    return ref && ref.href === targetHref;
  });
  if (exists) return null;

  const ref = moddle.create('dmn:DMNElementReference', { href: targetHref });
  const req = moddle.create('dmn:InformationRequirement', {
    id: 'Requirement_' + uid(),
    requiredInput: ref,
  });
  ref.$parent = req;
  req.$parent = decision;
  if (!decision.informationRequirement) decision.informationRequirement = [];
  decision.informationRequirement.push(req);
  return req;
}
